import { useState } from "react";
import {
  type HotelRoomRateProps,
  LodgingCancellationPolicyPopup,
} from "@b2bportal/core-hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import type { Prices } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./HotelRoomRate.module.scss";
import { useHotelRoomRate } from "./useHotelRoomRate";

export const HotelRoomRates = ({
  priceDifference,
  mealPlanRate = false,
  disabled = false,
  ...rest
}: HotelRoomRateProps & {
  priceDifference?: Prices;
  mealPlanRate?: boolean;
  disabled?: boolean;
}) => {
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelRoomRate);
  const { t, formatFiatCurrency } = useI18nContext();
  const { className } = rest;

  const { text, mealPlans } = useHotelRoomRate(rest);
  const [policyPopupOpen, setPolicyPopupOpen] = useState(false);

  // Only the base rate (not meal-plan sub-rates) shows the full policy link.
  const fullPolicyText = mealPlanRate ? undefined : text.fullPolicyText;

  return (
    <div className={clsx(block, className, disabled && cn("disabled"))}>
      <div>
        <div className={cn("title")}>
          {mealPlanRate ? mealPlans.planName : text.title}
        </div>
        {fullPolicyText && (
          <>
            <button
              type="button"
              className={cn("see-more")}
              onClick={() => setPolicyPopupOpen(true)}
            >
              {t("core-hotels.roomSelection.seeMoreDetails")}
            </button>
            <LodgingCancellationPolicyPopup
              openLodgingCancellationPolicyPopup={policyPopupOpen}
              onClose={() => setPolicyPopupOpen(false)}
            >
              <p>{fullPolicyText}</p>
            </LodgingCancellationPolicyPopup>
          </>
        )}
      </div>

      {priceDifference && priceDifference.fiat.value > 0 && (
        <div className={cn("price-difference")}>
          + {formatFiatCurrency(priceDifference.fiat)}
        </div>
      )}
    </div>
  );
};
